import { useEffect } from 'react';
import * as Yup from 'yup';
import { AppContextStates } from '@service-victoria/component-library/components/Wizard/props';
import * as steps from '../steps';

function useValidatePreviousStep(step: string, appContext: AppContextStates) {
  useEffect(() => {
    function validatePreviousStep() {
      switch (step) {
        case steps.Assess.Step.id:
          // Check Identity schema is valid
          (steps.Identity.Step.validation?.schema as Yup.Schema<any>)
            .validate(appContext.form.values)
            .catch(() => {
              // Goto to Identity step if Identity validation fails
              appContext.wizard.dispatch({
                type: 'GOTO_STEP',
                stepId: steps.Identity.Step.id,
                values: appContext.form.values
              });
            });
          break;

        case steps.Review.Step.id:
          // First check Identity schema is valid
          (steps.Identity.Step.validation?.schema as Yup.Schema<any>)
            .validate(appContext.form.values)
            .then(() => {
              // Then check Assess schema is valid
              (steps.Assess.Step.validation?.schema as Yup.Schema<any>)
                .validate(appContext.form.values)
                .catch(() => {
                  // Goto to Assess step if Assess validation fails
                  appContext.wizard.dispatch({
                    type: 'GOTO_STEP',
                    stepId: steps.Assess.Step.id,
                    values: appContext.form.values
                  });
                });
            })
            .catch(() => {
              // Goto to Identity step if Identity validation fails
              appContext.wizard.dispatch({
                type: 'GOTO_STEP',
                stepId: steps.Identity.Step.id,
                values: appContext.form.values
              });
            });
          break;
      }
    }
    validatePreviousStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useValidatePreviousStep;
